export default __webpack_public_path__ + "static/media/01_Kom_BOW+.fb71d5d7.png";